import { useContext } from "react";
import { UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrderContext } from "../../../contexts/OrderContext";
import { EOrderTipForm } from "../../../services/types";
import { TipSummaryItem } from "./TipSummaryItem";

export const OrderTipSummary = ({ watch }: { watch: UseFormWatch<EOrderTipForm> }) => {
	const { t } = useTranslation();
	const { currency } = useContext(OrderContext);
	const tipFromList = watch("tip");
	const customTip = watch("custom_amount");
	const tipValueToBeRendered = tipFromList !== null ? tipFromList : customTip || 0;

	return (
		<div data-testid="order-tip-summary-container">
			<div className="order-tips-charges">
				<TipSummaryItem chargeName={t("modules.e_order.field.tip.title")} price={tipValueToBeRendered} />
			</div>
			<div className="order-tips-summary" data-testid="order-tip-summary">
				<span>{t("common.word.amount")}</span>
				<span>{FormatMoney({ amount: tipValueToBeRendered, currency: currency ?? "PLN" })}</span>
			</div>
		</div>
	);
};
